import React, { useContext, useState } from "react";

import { Link } from "react-router-dom";
import { Row, Col, Form, FloatingLabel, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import "react-form-wizard-component/dist/style.css";

export default function AddMedicalCare() {
  const [values, setValues] = useState({
    selectFamily: "",
    selectPerson: "",
    doctorName: "",
    hospitalName: "",
    amount: "",
    amountRecieptFile: {},
    medicalReason: "",
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setValues((prevState) => ({
        ...prevState,
        [name]: files[0],
      }));
    } else {
      setValues((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(values);
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Add New Medical Care"}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"Families"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"Add New Medical Care"}</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <div className="card">
        <div className="card-header">Medical Care Form</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <Row>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Select Family"
                  className="mb-3"
                >
                  <Form.Select
                    required
                    type="text"
                    name="selectFamily"
                    placeholder=""
                    value={values.selectFamily}
                    onChange={handleChange}
                  >
                    <option>Select...</option>
                    <option>FSF 1</option>
                    <option>FSF 2</option>
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingSelect"
                  label="Select Person"
                  className="mb-3"
                >
                  <Form.Select
                    required
                    type="text"
                    name="selectPerson"
                    placeholder=""
                    value={values.selectPerson}
                    onChange={handleChange}
                  >
                    <option>Select...</option>
                    <option>Person 1</option>
                    <option>Person 2</option>
                    <option>Person 3</option>
                    <option>Person 4</option>
                    <option>Person 5</option>
                    <option>Person 6</option>
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingInputGrid"
                  label="Doctor's Name"
                  className="mb-3"
                >
                  <Form.Control
                    required
                    type="text"
                    name="doctorName"
                    placeholder=""
                    value={values.doctorName}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Hospital's Name"
                  className="mb-3"
                >
                  <Form.Control
                    required
                    type="text"
                    name="hospitalName"
                    placeholder=""
                    value={values.hospitalName}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Amount"
                  className="mb-3"
                >
                  <Form.Control
                    required
                    type="text"
                    name="amount"
                    placeholder=""
                    value={values.amount}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} controlId="formFileMultiple">
                <FloatingLabel>
                  <FloatingLabel label="Amount Reciept">
                    <Form.Control
                      required
                      name="amountRecieptFile"
                      onChange={handleChange}
                      type="file"
                      placeholder="Amount Reciept"
                      style={{ height: "60px" }}
                    />
                  </FloatingLabel>
                </FloatingLabel>
              </Form.Group>
              <Form.Group>
                <FloatingLabel
                  controlId="floatingInputGrid"
                  label="Medical Reason"
                >
                  <Form.Control
                    as="textarea"
                    required
                    type="text"
                    name="medicalReason"
                    value={values.medicalReason}
                    onChange={handleChange}
                    placeholder="Medical Reason"
                    style={{ height: "60px" }}
                  />
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Button className="py-2 my-3" variant="success" type="submit">
              Submit
            </Button>
          </form>
        </div>
      </div>
    </PageLayout>
  );
}
